module.exports = __webpack_public_path__ + "img/sloth-w-clock.75b17fcc.svg";